const oocCommands = ["fb", "fab", "nb", "rb"];

export default function isOocCommand(command: string) {
  return oocCommands.includes(command);
}
